import { Fragment, useCallback, useEffect, useState, useRef, useLayoutEffect } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Helmet } from "react-helmet";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import { useTranslation } from "react-i18next";
import axios from "axios";
import moment from "moment";
import { useParams, useHistory } from "react-router";
import ErrorLabel from "../../components/error";
import { DropDownInput1 } from "../../components/_input/_dropdown1";
import { OfferDetail } from "../../components/offerDetail";
import { Swiper, SwiperSlide } from "swiper/react";
import { getCleanSlug } from "../../utils/slugManager";
import config from "../../configuration/config";
import { DateInput3 } from "../../components/_input/_dateInput_3";
import Popup from "../../User/popup";
import CarUser from "../../User/components/CarUser";
import CarSupported from "./CarSupported";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import PhoneDropDown from "../../components/_input/_phoneDropDown";
import { InputField } from "../../components/_input/_input";
import { DropDownInput } from "../../components/_input/_dropdown";
import { TextArea } from "../../components/_input/_textArea";
import { useUserCart } from "../../User/hooks/useUserCart";
import { GetMessages, formValidate } from "../../utils/validation";
import { Price } from "../../components/__simple/_price";
import { now } from "moment";
import Moment from "react-moment";
import SimpleButton from "../../components/_input/SimpleButton";
import Joi from "joi";
import { getData, User_Data_Key } from "../../utils/localStorageManager";
import useTrackSelectVehicleOfferPromotion from "../../hooks/useTrackSelectVehicleOfferPromotion";
import * as trackingCarEvents from "../../services/trackingCarEvents";
import { useSwiperSettings } from "../../hooks/useSwiperSettings";

SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

const PackageDescription = ({ text, trans }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    if (!text) return null;
    const shouldShowBtn = text.length > 60;

    return (
        <div className="box-package-description">
            <p className={`package-desc ${isExpanded ? 'active' : 'clamped'}`}>
                {text}
            </p>
            {shouldShowBtn && (
                <span
                    className="show-more-pkg"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsExpanded(!isExpanded);
                    }}
                >
                    {isExpanded ? trans("common:show-less") : trans("common:show-more")}
                </span>
            )}
        </div>
    );
};

export function OfferVehiclesPage() {
    const { t: trans, i18n } = useTranslation(["common", "offers", "extra"]);
    const PERIODIC_MAINTENANCE_ID = 'EB199B7E-55BE-4AC8-B465-9A110B415CA8';
    let { slug } = useParams();
    const { changecartItem } = useUserCart();
    const history = useHistory();
    const languageDir = "language-" + localStorage.getItem("i18nextLng");
    const [isLogin, setLogin] = useState(false);
    const [Branches, setBranches] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showPopupPay, setShowPopupPay] = useState(null);
    const [warningPopup, setWarningPopup] = useState({ show: false, message: '' });
    const [banner, setBanner] = useState({});
    const [Note, setNote] = useState("");
    const [packages, setPackages] = useState([]);
    const [years, setYears] = useState([]);
    const [isSendeng, setIsSendeng] = useState(false);
    const [error, setError] = useState({});
    const [indexPanel, setIndexPanel] = useState("1000");
    const swiperSettings = useSwiperSettings();
    const [requestForm, setRequestForm] = useState({
        lastName: "",
        firstName: "",
        phone: "",
        email: "",
        subject: "",
        date: "",
        time: "",
        messageContent: "",
        myCarID: "",
        SiteID: null,
    });
    const [isDescExpanded, setIsDescExpanded] = useState(false);
    const LoginSchema = Joi.object({
        date: Joi.date().required().messages(GetMessages()),
        time: Joi.date().required().messages(GetMessages()),
        meterReading: Joi.string().required().messages(GetMessages()),
        SiteID: Joi.string().required().messages(GetMessages()),
        year: Joi.string().required().messages(GetMessages()),
        model: Joi.string().required().messages(GetMessages()),
    });
    const notLoginSchema = Joi.object({
        date: Joi.date().required().messages(GetMessages()),
        time: Joi.date().required().messages(GetMessages()),
        SiteID: Joi.string().required().messages(GetMessages()),
        meterReading: Joi.string().required().messages(GetMessages()),
        firstName: Joi.string().required().messages(GetMessages()),
        lastName: Joi.string().required().messages(GetMessages()),
        phone: Joi.string().required().messages(GetMessages()),
        year: Joi.string().required().messages(GetMessages()),
        model: Joi.string().required().messages(GetMessages()),
    });
    const [offer, setOffer] = useState(null);
    const [offerSupportedCars, setOfferSupportedCars] = useState([]);
    const [packageSupportedCars, setPackageSupportedCars] = useState([]);
    const [acticeService, setActiceService] = useState(null);
    const [acticeCar, setActiceCar] = useState(null);
    const [acticePackage, setActicePackage] = useState(null);
    const [isLoadingOffer, setIsLoadingOffer] = useState(true);
    const [isLoadingSupportedServices, setLoadingSupportedServices] = useState(true);
    const [isLoadingSupportedVehicles, setLoadingSupportedVehicles] = useState(true);


    let lang = i18n.language || "ar";


    useEffect(() => {
        try {
            window.tamaraWidgetConfig = {
                lang: lang,
                country: "SA",
                publicKey: "71258997-64ec-418a-9cba-0d3849fa219f",
            };
            window.TamaraFAQsFrame.render({ lang: lang });
        } catch (error) { }

        let data = {};
        try {
            data = JSON.parse(getData(User_Data_Key, true));
        } catch (error) { }
        try {
            if (getData("isAuthenticated")) setLogin(true);
        } catch (err) {
            setLogin(false);
        }
    }, [lang]);

    var tamarFAQsConfig = {
        lang: "ar",
        styles: { width: "100%", height: "100%" },
        autoRender: false,
        tamaraLogo: false,
    };

    const [fullDatetime, setFullDatetime] = useState(null);
    useEffect(() => {
        try {
            if (requestForm?.date) {
                var md = new Date(requestForm?.date);
                try {
                    if (requestForm?.time) {
                        var Hours = requestForm?.time.split(":");
                        md.setHours(Hours[0], Hours[1], 0);
                    }
                } catch (error) { }
                var datetime = new moment(md).format("yyyy-MM-DD HH:mm:ss");
                setFullDatetime(datetime);
                console.log("datetime:", datetime);
            }
        } catch (error) { }
    }, [requestForm]);

    useEffect(() => {
        var ly = [];
        try {
            if (acticeCar?.fromYear && acticeCar?.toYear) {
                if (acticeCar?.fromYear == acticeCar?.toYear) {
                    ly.push({ value: acticeCar.fromYear, text: acticeCar.fromYear });
                    setYears(ly);
                    const val = { ...requestForm };
                    val.year = acticeCar.fromYear + "";
                    setRequestForm(val);
                    return;
                }
                ly.push({ value: acticeCar.fromYear, text: acticeCar.fromYear });
                var newy = parseInt(acticeCar.fromYear);
                for (var i = 0; i <= 30; i++) {
                    newy = parseInt(newy) + 1;
                    ly.push({ value: newy, text: newy });
                    if (newy >= acticeCar?.toYear) {
                        break;
                    }
                }
                setYears(ly);
            }
        } catch (error) { }
    }, [acticeCar]);

    const callback = useCallback(async () => {
        setIsLoadingOffer(true);
        try {
            try {
                if ("caches" in window) {
                    let url = "detail-" + getCleanSlug();
                    const cacheStorage = await caches.open("OfferPage");
                    const cachedResponse = await cacheStorage.match(url);
                    var data = await cachedResponse?.json();
                    if (data) {
                        setBanner(data?.banner);
                        setPackages(data?.packages);
                        setOffer(data?.offer);
                        setOfferSupportedCars(data?.offerSupportedCars);
                        setPackageSupportedCars(data?.packagesSupportedCars);
                        if (data?.packages.length > 0) {
                            setActicePackage(data?.packages[0]);
                        }
                        setIsLoadingOffer(false);
                    }
                }
            } catch (error) { }
            const response = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/offers/detail/" + getCleanSlug(),
                method: "get",
            });
            setBanner(response.data.banner);
            setPackages(response.data.packages);
            setOffer(response.data.offer);
            setOfferSupportedCars(response.data.offerSupportedCars);
            setPackageSupportedCars(response.data.packagesSupportedCars);
            if (response.data.packages.length > 0) {
                setActicePackage(response.data.packages[0]);
            }
            setIsLoadingOffer(false);
            const Responsedata = new Response(JSON.stringify(response.data));
            if ("caches" in window) {
                caches.open("OfferPage").then((cache) => {
                    cache.put("detail-" + getCleanSlug(), Responsedata);
                });
            }
        } catch (error) {
            console.log(error);
            setIsLoadingOffer(false);
        }
    }, [lang, slug]);

    const FetchOfferSupportedServicesSacondry = useCallback(async () => {
        try {
            const cslug = await getCleanSlug();
            await axios
                .post(`${config.controllURL}${lang}/api/Pages/Site_FetchOfferSupportedServices`, { slug: cslug })
                .then(function (response) {
                    var Mainservice = [];
                    var Lastservice = [];
                    var MainserviceIDS = [];
                    response.data?.map((item, index) => {
                        if (item?.ServiceID) {
                            if (!Lastservice.includes(item)) {
                                Lastservice.push(item);
                                MainserviceIDS.push(item?.subService2);
                            }
                        } else if (item?.subService2) {
                            if (!Mainservice.includes(item)) {
                                Mainservice.push(item);
                            }
                        }
                    });
                    Mainservice = Mainservice.filter((item) => !MainserviceIDS.includes(item?.subService2));
                    setSupportedMainServices(Mainservice);
                    setSupportedLastsServices(Lastservice);
                    if (Lastservice[0]) setActiceService(Lastservice[0]);
                    setSupportedServices(response.data);
                    setLoadingSupportedServices(false);
                    const Responsedata = new Response(JSON.stringify(response.data));
                    if ("caches" in window) {
                        caches.open("OfferPage").then((cache) => {
                            cache.put("Site_FetchOfferSupportedCampaignTransServices-" + getCleanSlug(), Responsedata);
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    setLoadingSupportedServices(false);
                });
        } catch (error) { }
    }, []);
    const [SupportedServices, setSupportedServices] = useState([]);
    const [SupportedMainServices, setSupportedMainServices] = useState([]);
    const [SupportedLastsServices, setSupportedLastsServices] = useState([]);

    const FetchOfferSupportedServices = useCallback(async () => {
        try {
            setLoadingSupportedServices(true);
            try {
                if ("caches" in window) {
                    let url = "Site_FetchOfferSupportedCampaignTransServices-" + getCleanSlug();
                    const cacheStorage = await caches.open("OfferPage");
                    const cachedResponse = await cacheStorage.match(url);
                    var data = await cachedResponse?.json();
                    if (data) {
                        var Mainservice = [];
                        var Lastservice = [];
                        var MainserviceIDS = [];
                        data?.map((item, index) => {
                            if (item?.ServiceID) {
                                if (!Lastservice.includes(item)) {
                                    Lastservice.push(item);
                                    MainserviceIDS.push(item?.subService2);
                                }
                            } else if (item?.subService2) {
                                if (!Mainservice.includes(item)) {
                                    Mainservice.push(item);
                                }
                            }
                        });
                        Mainservice = Mainservice.filter((item) => !MainserviceIDS.includes(item?.subService2));
                        setSupportedMainServices(Mainservice);
                        setSupportedLastsServices(Lastservice);
                        if (Lastservice[0]) setActiceService(Lastservice[0]);
                        setSupportedServices(data);
                        setLoadingSupportedServices(false);
                    }
                }
            } catch (error) { }
            const cslug = await getCleanSlug();
            await axios
                .post(`${config.controllURL}${lang}/api/Pages/Site_FetchOfferSupportedCampaignTransServices`, { slug: cslug })
                .then(function (response) {
                    var Mainservice = [];
                    var Lastservice = [];
                    var MainserviceIDS = [];
                    response.data?.map((item, index) => {
                        if (item?.ServiceID) {
                            if (!Lastservice.includes(item)) {
                                Lastservice.push(item);
                                MainserviceIDS.push(item?.subService2);
                            }
                        } else if (item?.subService2) {
                            if (!Mainservice.includes(item)) {
                                Mainservice.push(item);
                            }
                        }
                    });
                    Mainservice = Mainservice.filter((item) => !MainserviceIDS.includes(item?.subService2));
                    setSupportedMainServices(Mainservice);
                    setSupportedLastsServices(Lastservice);
                    if (Lastservice[0]) setActiceService(Lastservice[0]);
                    setSupportedServices(response.data);
                    setLoadingSupportedServices(false);
                    const Responsedata = new Response(JSON.stringify(response.data));
                    if ("caches" in window) {
                        caches.open("OfferPage").then((cache) => {
                            cache.put("Site_FetchOfferSupportedCampaignTransServices-" + getCleanSlug(), Responsedata);
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    FetchOfferSupportedServicesSacondry();
                });
        } catch (error) {
            console.log(error);
            setLoadingSupportedServices(false);
        }
    }, []);

    const [SupportedVehicles, setSupportedVehicles] = useState([]);


    const FetchOfferSupportedVehicles = useCallback(async () => {
        try {
            setLoadingSupportedVehicles(true);
            try {
                if ("caches" in window) {
                    let url = "Site_FetchOfferSupportedAllTypesVehicles-" + getCleanSlug();
                    const cacheStorage = await caches.open("OfferPage");
                    const cachedResponse = await cacheStorage.match(url);
                    var data = await cachedResponse?.json();
                    if (data) {
                        setSupportedVehicles(data);
                        setLoadingSupportedVehicles(false);
                    }
                }
            } catch (error) { }
            await axios
                .post(`${config.controllURL}${lang}/api/Pages/Site_FetchOfferSupportedAllTypesVehicles`, { slug: getCleanSlug() })
                .then(function (response) {
                    var supCars = response.data;
                    setSupportedVehicles(response.data);
                    setLoadingSupportedVehicles(false);
                    const Responsedata = new Response(JSON.stringify(response.data));
                    if ("caches" in window) {
                        caches.open("OfferPage").then((cache) => {
                            cache.put("Site_FetchOfferSupportedAllTypesVehicles-" + getCleanSlug(), Responsedata);
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    setLoadingSupportedVehicles(false);
                });
        } catch (error) {
            console.log(error);
            setLoadingSupportedVehicles(false);
        }
    }, []);

    const handelshowPup = (type) => {
        setShowPopup(true);
    };

    function SendResreve(VIN, MainServiceID, subServiceID, TypeServiceID, ServecID, ModelCode, UserID, Amount) {
        var thisSchema = null;
        if (isLogin) {
            thisSchema = LoginSchema;
        } else {
            thisSchema = notLoginSchema;
        }
        const result = formValidate(thisSchema, requestForm) ?? {};
        setError(result);
        if (Object.keys(result).length == 0 && isSendeng == false) {
            if (SupportedLastsServices?.length <= 0) {
                toast.warn(trans("offers:services_supported") + " (0)");
                return;
            }
            setIsSendeng(true);
            var ServicesList = "";
            SupportedLastsServices.map((a) => {
                ServicesList += a.ServiceID + ",";
            });
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = {
                VIN: requestForm?.VIN,
                Model: acticeCar?.type,
                Year: requestForm?.year ? requestForm?.year + "" : null,
                CarType: acticeCar?.modelCode,
                UserID: UserID ?? "",
                TotalAmount: Amount ? Amount : 0,
                MainServiceID: MainServiceID,
                subServiceID: subServiceID,
                TypeServiceID: TypeServiceID,
                ServiceID: ServecID,
                RequiredServicesList: ServicesList,
                Note: Note,
                MeterReading: requestForm?.meterReading,
                FirstName: requestForm?.firstName,
                LastName: requestForm?.lastName,
                phone: requestForm?.phone,
                Email: requestForm?.email,
                StoreID: requestForm?.SiteID,
                Orderdate: moment(requestForm?.date).format("YYYY-MM-DD"),
                OrderTime: moment(requestForm?.time).format("HH:mm:ss"),
                PackageId: acticeCar?.packageId ? acticeCar?.packageId + "" : null,
            };
            axios
                .request({
                    url: config.controllURL + "api/Service/ServiceRequestAdd",
                    headers: myHeaders,
                    data: raw,
                    method: "POST",
                    responseType: "json",
                })
                .then(function (response) {
                    setShowPopup(false);
                    toast.success(trans("info:reservation_completed_successfully"));
                })
                .then((response) => {
                    setIsSendeng(false);
                })
                .catch((error) => {
                    setIsSendeng(false);
                });
        } else {
            console.log("result>>>>>>>>>>>>>>>>>:", result);
        }
    }

    async function GetBranch() {
        await axios
            .request({
                url: `${config.controllURL}${lang}/api/Pages/site_FetchMaintenanceBranches`,
                data: {},
                method: "POST",
                responseType: "json",
            })
            .then(function (response) {
                setBranches(response.data);
                setTimeout(() => {
                    if (response?.data?.length == 1) {
                        const val = { ...requestForm };
                        val.SiteID = response?.data[0]?.SiteID;
                        setRequestForm(val);
                    }
                }, 1000);
            })
            .catch(function (error) { });
    }

    const [listTimeAvailable, setListTimeAvailable] = useState([]);

    const webAvailableReshours = async (date = "", serviceGuid = null) => {
        const Body = { Resdate: date, ServiceGuid: serviceGuid };
        await axios
            .request({
                url: `${config.controllURL}${lang}/api/Pages/web_AvailableReshours`,
                data: Body,
                method: "POST",
                responseType: "json",
            })
            .then(function (response) {
                console.log("web_AvailableReshours:response", response);
                if (response.status >= 200 && response.status < 299) {
                    if (response?.data && response?.data.length != 0) {
                        response?.data.forEach((val, index) => {
                            setListTimeAvailable((_lstTime) => [..._lstTime, parseInt(val?.AvailableHour)]);
                        });
                    }
                }
            })
            .catch(function (error) {
                console.log("web_AvailableReshours:Error", error);
                toast.warn(trans("form:please-choose-another-date"));
            });
    };

    useTrackSelectVehicleOfferPromotion({ banner, SupportedVehicles, lang });

    useEffect(() => {
        window.scrollTo(0, 0);
        callback();
        FetchOfferSupportedServicesSacondry();
        FetchOfferSupportedVehicles();
        GetBranch();
    }, [callback, FetchOfferSupportedServicesSacondry, FetchOfferSupportedVehicles]);

    return (
        <Fragment>
            {banner && (
                <Helmet>
                    <meta charSet="utf-8" />
                    {banner?.title && <title>{banner?.title}</title>}
                    {<link rel="canonical" href={`${window.location.origin}${window.location.pathname}${window.location.search}`} />}
                    {banner?.excerpt && <meta name="description" content={banner?.excerpt} />}
                    {banner?.type && <meta name="keywords" content={banner?.type} />}
                    {banner?.image && <meta property="og:image" content={config?.mainURL + banner?.image} name="image" />}
                </Helmet>
            )}

            {/* Updated: Offer Banner Section – resembles the hero section with a card-like container */}
            <section className="sec offer-hero">
                <div className="ctn">
                    <div className="offer-hero-card">
                        <div className="offer-hero-left">
                            {isLoadingOffer ? (
                                <div className="space-y-4">
                                    <Skeleton width={120} height={28} borderRadius={10} className="mb-4" />
                                    <Skeleton height={50} width="80%" borderRadius={12} className="mb-6" />
                                    <Skeleton count={3} height={20} borderRadius={8} className="mb-4" />
                                    <Skeleton width={180} height={45} borderRadius={10} className="mt-6" />
                                </div>
                            ) : (
                                <>
                                    <div className="stag">{banner?.type}</div>
                                    {banner?.image && (
                                        <div className="offer-hero-img-mobile">
                                            <img
                                                src={config?.mainURL + banner?.image}
                                                alt={banner?.title}
                                                onError={(e) => (e.target.style.display = "none")}
                                            />
                                        </div>
                                    )}
                                    <h1 className="sh">{banner?.title}</h1>
                                    {banner?.endDate && (
                                        <div className="offer-timer">
                                            <span className="timer-label">{trans("offers:end-in")}</span>
                                            <Moment duration={now()} format={"D"} date={banner?.endDate} className="timer-number" />
                                            <span className="timer-unit">{trans("offers:day")}</span>
                                            <span className="timer-sep">|</span>
                                            <span className="timer-label">{trans("offers:date")}</span>
                                            <Moment className="timer-number" format={"DD/MM/YYYY"} date={banner?.endDate} />
                                        </div>
                                    )}
                                    {offer?.content && (
                                        <>
                                            <div className={`offer-desc ${!isDescExpanded ? "clamped" : ""}`}>
                                                {offer?.content.split("\n").map((item, idx) => (
                                                    item?.trim() && <p key={idx} className="offer-desc-item">{item}</p>
                                                ))}
                                            </div>
                                            {offer?.content.split("\n").filter(i => i.trim()).length > 2 && (
                                                <button
                                                    className={`show-more-btn ${isDescExpanded ? "expanded" : ""}`}
                                                    onClick={() => setIsDescExpanded(!isDescExpanded)}
                                                >
                                                    {isDescExpanded ? trans("common:show-less") : trans("common:show-more")}
                                                </button>
                                            )}
                                        </>
                                    )}
                                    <div className="offer-actions">
                                        {!acticeCar && <div className="offer-hint"> {trans("info:Vehicle-must-be-selected")}</div>}
                                        <SimpleButton
                                            classes={`btn-primary ${!acticeCar ? 'btn-disabled opacity-50 cursor-not-allowed' : ''}`}
                                            title={trans("info:request-offer")}
                                            onClick={() => {
                                                if (acticeCar && acticeCar?.ProductID)
                                                    history.push(`/order-car?vehicle=${acticeCar?.ProductID}&model=${acticeCar.fromYear}&type=${acticeCar.type}&color=${acticeCar?.ColorID}`);
                                                else toast.info(trans("info:select_car"));
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="offer-hero-right">
                            {isLoadingOffer ? (
                                <Skeleton height="100%" width="100%" borderRadius={24} />
                            ) : banner?.image && (
                                <div className="offer-hero-img">
                                    <img
                                        src={config?.mainURL + banner?.image}
                                        alt={banner?.title}
                                        onError={(e) => (e.target.style.display = "none")}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* Packages Section */}
            {(isLoadingOffer || packages?.length > 0) && (
                <section className="sec">
                    <div className="ctn">
                        {isLoadingOffer ? (
                            <>
                                <Skeleton width={100} height={25} borderRadius={8} className="mb-4" />
                                <Skeleton width={300} height={40} borderRadius={10} className="mb-8" />
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                                    <Skeleton height={180} borderRadius={20} count={4} />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="stag">{trans("offers:packages")}</div>
                                <h2 className="sh">{trans("offers:choose_package")} <span className="gn">{packages.length}</span></h2>
                                <Swiper
                                    spaceBetween={20}
                                    slidesPerView={1.6}
                                    breakpoints={{ 576: { slidesPerView: 2.5 }, 768: { slidesPerView: 3.5 }, 1024: { slidesPerView: 4.5 } }}
                                    pagination={{ clickable: true }}
                                    autoplay={false}
                                    loop={false}
                                    observer={true}
                                    className="package-swiper"
                                >
                                    {packages?.map((data, index) => (
                                        <SwiperSlide key={index}>
                                            <div
                                                className={`box-package-detail ${data?.id === acticePackage?.id ? 'active' : ''}`}
                                                onClick={() => {
                                                    setActiceCar(null);
                                                    if (acticePackage?.id === data?.id) {
                                                        setActicePackage(null);
                                                        return;
                                                    }
                                                    setActicePackage(data);
                                                }}
                                            >
                                                <div className="box-package-detail-name">
                                                    <h3 className="box-package-title">{data?.title}</h3>
                                                    {offer?.reservationOnly !== true && data?.price && (
                                                        <h5 className="box-package-price">
                                                            <Price price={data?.price} />
                                                        </h5>
                                                    )}
                                                </div>
                                                <PackageDescription text={lang === 'ar' ? data?.descriptionAr : data?.descriptionEn} trans={trans} />
                                                <div className="box-package-selection">
                                                    <span className="selection-label">
                                                        {data?.id === acticePackage?.id ? trans("offers:selected") : trans("offers:select")}
                                                    </span>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </>
                        )}
                    </div>
                </section>
            )}

            {/* Supported Vehicles Section */}
            {(isLoadingSupportedVehicles || SupportedVehicles?.length > 0) && (
                <section className="sec">
                    <div className="ctn">
                        {isLoadingSupportedVehicles ? (
                            <>
                                <Skeleton width={150} height={25} borderRadius={8} className="mb-4" />
                                <Skeleton width={400} height={40} borderRadius={10} className="mb-8" />
                                <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                                    <Skeleton height={250} borderRadius={24} count={4} />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="stag">{trans("info:Vehicle-must-be-selected")}</div>
                                <h2 className="sh">
                                    {trans("offers:vehicles_supported")}{' '}
                                    <span className="gn">
                                        {(acticePackage?.id ? SupportedVehicles.filter((a) => a.packageId === acticePackage?.id) : SupportedVehicles)?.length}
                                    </span>
                                </h2>
                                <Swiper
                                    spaceBetween={20}
                                    slidesPerView={1.2}
                                    breakpoints={{
                                        576: { slidesPerView: 1.5 },
                                        768: { slidesPerView: 2.5 },
                                        1024: { slidesPerView: 3.5 },
                                        1200: { slidesPerView: 4 }
                                    }}
                                    pagination={{ clickable: true }}
                                    className="supported-vehicles-swiper"
                                    style={{ paddingBottom: '30px' }}
                                >
                                    {(acticePackage?.id ? SupportedVehicles.filter((a) => a.packageId === acticePackage?.id) : SupportedVehicles)?.map((data, index) => (
                                        <SwiperSlide key={index}>
                                            <div
                                                className={`vc car-card ${data.slug === acticeCar?.slug ? "active" : ""}`}
                                                onClick={() => {
                                                    trackingCarEvents.trackSelectCar(data, "offer_supported_vehicles", "Offer Supported Vehicles");
                                                    setActiceCar(data);
                                                }}
                                            >
                                                <div className="vc-img">
                                                    <img src={data.image ? config.FilePathURL + data.image : "/assets/images/parts/default.png"} alt={data.shortDescriptionEn} />
                                                    {data.slug === acticeCar?.slug && <div className="vc-selection-badge"><i className="fa fa-check"></i></div>}
                                                </div>
                                                <div className="vc-body">
                                                    <div className="vc-name">{lang === "ar" ? data?.brand : data?.brandEn} {(lang === "ar" ? (data?.group || data?.shortDescriptionAr) : (data?.groupEn || data?.shortDescriptionEn))?.toString().trim()}</div>
                                                    <div className="vc-sub">
                                                        {data?.modelCode} {data?.fromYear && `(${data.fromYear}${data.toYear ? ` - ${data.toYear}` : ''})`}
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </>
                        )}
                    </div>
                </section>
            )}

            {/* Offer Detail – includes packages, services, etc. */}
            <section className="sec">
                <div className="ctn">
                    <OfferDetail
                        desc={offer?.content}
                        terms={offer?.name}
                        slug={slug}
                        offerId={banner?.id}
                        supportedCars={SupportedVehicles}
                        SupportedServices={SupportedServices}
                        SupportedMainServices={SupportedMainServices}
                        SupportedLastsServices={SupportedLastsServices}
                        packages={packages}
                        acticePackage={acticePackage}
                        handelActiceCar={(value) => {
                            setActiceCar(value);
                            var pac = packages?.filter((a) => a.id == value?.packageId)[0];
                            if (pac) setActicePackage(pac);
                            setShowPopup(true);
                        }}
                        handelActiceService={(value) => { }}
                        handleActicePackage={(value) => {
                            setActicePackage(value);
                            setActiceCar(null);
                            setShowPopup(true);
                        }}
                    />
                </div>
            </section>

            {/* Installments Widgets (Tabby/Tamara) */}
            {offer?.allowInstallments && (
                <section className="sec installments">
                    <div className="ctn">
                        <h2 className="sh">{trans("info:buy-now-pay-later")}</h2>
                        <div className="installment-grid">
                            <div
                                className="installment-card tabby"
                                onClick={() => setShowPopupPay("tabby")}
                            >
                                <img src="/assets/icons/tabby.png" alt="Tabby" />
                                <p>
                                    {trans("info:pay-4-interest-free-payments")}
                                    {acticePackage?.price && (
                                        <span>
                                            {" "}{lang == "ar" ? " بقيمة " : " of "} <Price price={acticePackage?.price / 4} />
                                        </span>
                                    )}
                                </p>
                            </div>
                            <div
                                className="installment-card tamara"
                                onClick={() => setShowPopupPay("tamara")}
                            >
                                <img src={`/assets/icons/${lang == "ar" ? "Ar-tamara.svg" : "En-tamara.svg"}`} alt="Tamara" />
                                <p>
                                    {trans("info:pay-4-interest-free-payments")}
                                    {acticePackage?.price && (
                                        <span>
                                            {" "}{lang == "ar" ? " بقيمة " : " of "} <Price price={acticePackage?.price / 4} />
                                        </span>
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            {/* Reservation Popup – modal with form */}
            <Popup show={showPopup}>
                <div className="modal-overlay">
                    <div className="modal offer-modal">
                        <button className="modal-close" onClick={() => setShowPopup(false)}>✕</button>
                        <div className="modal-header">
                            <h2>{trans("info:request-offer")}</h2>
                            <p className="modal-subtitle">{banner?.title}</p>
                        </div>
                        <div className="modal-body">
                            {!isLogin && (
                                <>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <InputField
                                                errorLabel={error?.firstName}
                                                placeholder={trans("form:first-name")}
                                                value={requestForm.firstName}
                                                length={255}
                                                onChangeValue={(e) => setRequestForm({ ...requestForm, firstName: e.target.value })}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <InputField
                                                errorLabel={error?.lastName}
                                                placeholder={trans("info:surname")}
                                                value={requestForm.lastName}
                                                length={255}
                                                onChangeValue={(e) => setRequestForm({ ...requestForm, lastName: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <PhoneDropDown
                                            title={trans("form:phone")}
                                            errorLabel={error?.phone}
                                            onChangeValue={(countryCode, phoneNumber) => {
                                                const val = { ...requestForm };
                                                val.phone = phoneNumber ? `+${countryCode}${phoneNumber}` : "";
                                                setRequestForm(val);
                                            }}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <InputField
                                            value={requestForm.email}
                                            type="email"
                                            onChangeValue={(e) => setRequestForm({ ...requestForm, email: e.target.value })}
                                            errorLabel={error?.email}
                                            placeholder={trans("form:email")}
                                        />
                                    </div>
                                </>
                            )}
                            {(isLogin || (requestForm?.phone && requestForm?.lastName && requestForm?.firstName)) && (
                                <>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <DropDownInput1
                                                title={trans("info:model")}
                                                errorLabel={error?.model}
                                                options={SupportedVehicles.filter((a) => a.packageId == acticePackage?.id).map((B) => ({
                                                    value: B.slug,
                                                    text: lang == "ar" ? B.DescriptionAr : B.DescriptionEn,
                                                }))}
                                                onSelect={(value) => {
                                                    setRequestForm({ ...requestForm, model: value, year: null });
                                                    var car = SupportedVehicles.find((a) => a.slug == value);
                                                    if (car) setActiceCar(car);
                                                }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <DropDownInput1
                                                title={trans("info:vehicle_year")}
                                                errorLabel={error?.year}
                                                options={years}
                                                selectedValue={requestForm?.year}
                                                onSelect={(value) => setRequestForm({ ...requestForm, year: value + "" })}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <InputField
                                                title={trans("info:meter-reading")}
                                                errorLabel={error?.meterReading}
                                                placeholder={trans("info:meter-reading")}
                                                type="number"
                                                onChangeValue={(e) => setRequestForm({ ...requestForm, meterReading: e.target.value })}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <InputField
                                                errorLabel={error?.VIN}
                                                title={trans("form:structure-no") + " (VIN)"}
                                                placeholder={trans("form:structure-no") + " (VIN)"}
                                                onChangeValue={(e) => setRequestForm({ ...requestForm, VIN: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {requestForm?.meterReading && requestForm?.year && requestForm?.model && (
                                <>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <DatePicker
                                                isClearable={!!requestForm.date}
                                                className="datepicker-input"
                                                selected={requestForm.date}
                                                onChange={async (value) => {
                                                    const selectedDate = moment(value).format("yyyy-MM-DD");
                                                    const today = moment().format("yyyy-MM-DD");
                                                    const isToday = selectedDate === today;
                                                    const serviceGuid = acticeService?.subService1;
                                                    const hasRestricted = serviceGuid?.toUpperCase() !== PERIODIC_MAINTENANCE_ID;
                                                    if (isToday && hasRestricted) {
                                                        setWarningPopup({
                                                            show: true,
                                                            message: lang === 'ar'
                                                                ? "هذه الخدمة لا يمكن حجزها في نفس اليوم، يرجى اختيار تاريخ آخر (ابتداءً من الغد)."
                                                                : "This service cannot be booked on same day, please choose another date (starting from tomorrow)."
                                                        });
                                                        return;
                                                    }
                                                    setRequestForm({ ...requestForm, date: value, time: null });
                                                    setListTimeAvailable([]);
                                                    if (value) await webAvailableReshours(selectedDate, serviceGuid);
                                                }}
                                                filterDate={(date) => {
                                                    const today = new Date();
                                                    const yesterday = new Date(today);
                                                    yesterday.setDate(today.getDate() - 1);
                                                    const day = date.getDay();
                                                    return (day !== 5) && new Date(date).setHours(0, 0, 0) > yesterday.setHours(0, 0, 0); // exclude Friday?
                                                }}
                                                placeholderText={trans("form:maintenance-date")}
                                                dateFormat="yyyy-MM-DD"
                                                customInput={<DateInput3 value={moment(requestForm.date).format("yyyy-MM-DD")} />}
                                            />
                                            <ErrorLabel errorTitle={error?.date} />
                                        </div>
                                        <div className="form-group">
                                            <DatePicker
                                                includeTimes={listTimeAvailable.map((val) => {
                                                    const time = new Date();
                                                    let res;
                                                    const serviceGuid = acticeService?.subService1;
                                                    const hasRestricted = serviceGuid?.toUpperCase() !== PERIODIC_MAINTENANCE_ID;
                                                    if (hasRestricted && val > 13) { }
                                                    else if (requestForm.date && new Date(requestForm.date).toDateString() === new Date().toDateString()) {
                                                        if (val > new Date().getHours()) res = time.setHours(val, 0, 0);
                                                    } else if (requestForm.date && new Date(requestForm.date) > new Date()) {
                                                        res = time.setHours(val, 0, 0);
                                                    } else {
                                                        res = time.setHours(val, 0, 0);
                                                    }
                                                    return res;
                                                })}
                                                isClearable={!!requestForm.time}
                                                selected={requestForm.time}
                                                onChange={(value) => setRequestForm({ ...requestForm, time: value })}
                                                className="datepicker-input"
                                                placeholderText={trans("form:maintenance-time")}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                timeIntervals={60}
                                                timeCaption={trans("form:maintenance-time")}
                                                dateFormat="hh:mm aa"
                                                customInput={<DateInput3 />}
                                            />
                                            <ErrorLabel errorTitle={error?.time} />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <DropDownInput
                                                title={trans("info:branch")}
                                                errorLabel={error?.SiteID}
                                                options={Branches.map((B) => ({
                                                    value: B.SiteID,
                                                    text: lang === "ar" ? B.DescriptionAr : B.DescriptionEn,
                                                }))}
                                                selectedValue={Branches?.length == 1 ? Branches[0]?.SiteID : requestForm?.SiteID}
                                                onSelect={(value) => setRequestForm({ ...requestForm, SiteID: value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <TextArea row={5} title={trans("info:notes")} onChangeValue={setNote} />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn-primary"
                                onClick={() => {
                                    var cleanData = {};
                                    try { cleanData = JSON.parse(getData(User_Data_Key, true)); } catch (e) { }
                                    SendResreve(
                                        acticeCar?.type,
                                        acticeService?.mainService,
                                        acticeService?.subService1,
                                        acticeService?.subService2,
                                        acticeService?.ServiceID,
                                        null,
                                        cleanData?.custID,
                                        acticePackage?.price,
                                    );
                                }}
                            >
                                {trans("info:reserve")}
                            </button>
                            {offer?.reservationOnly !== true && (
                                <button
                                    className={`btn-secondary ${acticePackage?.price && acticeCar?.type ? "" : "disabled"}`}
                                    onClick={() => {
                                        if (acticePackage?.price && acticeCar?.type) {
                                            var objectCart = {
                                                id: acticeService?.ServiceID + "-" + acticeCar.type + "-" + acticeCar?.packageId,
                                                productID: acticeService?.ServiceID,
                                                name: acticeCar?.excerptAr,
                                                nameEn: acticeCar?.excerptEn,
                                                brand: acticeCar?.brand,
                                                brandEn: acticeCar?.brandEn,
                                                Tax: acticeCar?.Tax,
                                                image: banner?.image,
                                                Discount: acticeCar?.Discount,
                                                group: acticeCar?.group,
                                                groupEn: acticeCar?.groupEn,
                                                BrandID: acticeCar?.brandID,
                                                modelTypes: acticeCar?.DescriptionAr,
                                                modelTypesEn: acticeCar?.DescriptionEn,
                                                colorName: acticeCar["Color Araboc"],
                                                colorNameEn: acticeCar["Color English"],
                                                year: requestForm?.year,
                                                modelTypeID: acticeCar.type,
                                                MiniDownPayment: 0,
                                                price: acticePackage?.price,
                                                packageId: acticeCar?.packageId,
                                                Orderdate: fullDatetime,
                                                Type: "Bouquet",
                                            };
                                            changecartItem(
                                                objectCart?.productID,
                                                acticeCar?.ColorID,
                                                acticeCar.type,
                                                1,
                                                null,
                                                acticeCar?.packageId,
                                                objectCart,
                                                fullDatetime,
                                                requestForm?.year
                                            );
                                            setShowPopup(false);
                                        } else {
                                            toast.warning(trans("info:select_car"));
                                        }
                                    }}
                                >
                                    {trans("info:add_to_cart")} <img src="/assets/icons/cart.svg" className="w-9 h-9" alt="cart" />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </Popup>

            {/* Payment Popup (Tabby/Tamara) */}
            <Popup show={showPopupPay !== null}>
                <div className="modal-overlay">
                    <div className={`modal payment-modal ${showPopupPay}`}>
                        <button className="modal-close" onClick={() => setShowPopupPay(null)}>✕</button>
                        <div className="modal-body">
                            {showPopupPay === "tabby" ? (
                                <iframe
                                    className="payment-iframe"
                                    src={`https://checkout.tabby.ai/promos/product-page/installments/${lang}/${acticePackage?.price ? "?price=" + acticePackage?.price : "?price=0"}&currency=SAR`}
                                    title="Tabby"
                                />
                            ) : (
                                <iframe
                                    className="payment-iframe"
                                    src={`https://cdn.tamara.co/widget-v2/tamara-widget.html?lang=${lang}&widgetType=information-widget&public_key=98ca3489-55a5-4392-9010-671549dbfba2${acticePackage?.price ? "&amount=" + acticePackage?.price : "&amount=0"}&paymentType=installment`}
                                    title="Tamara"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </Popup>

            {/* Warning Popup */}
            <Popup show={warningPopup.show}>
                <div className="modal-overlay">
                    <div className="modal warning-modal">
                        <div className="modal-body">
                            <p className="warning-message">{warningPopup.message}</p>
                            <button
                                className="btn-primary"
                                onClick={() => setWarningPopup({ show: false, message: '' })}
                            >
                                {lang === 'ar' ? "موافق" : "OK"}
                            </button>
                        </div>
                    </div>
                </div>
            </Popup>

        </Fragment>
    );
}